/**
 * Labstep
 *
 * @module containers/Entity/Read/Entity/Any
 * @desc Container for reading one entity by ID
 */

import type { APICallOptions } from 'labstep-web/models';
import { readEntity } from 'labstep-web/state/actions/entity';
import { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import type { IEntityReadEntityAnyContainerProps } from './types';

export type EntityReadEntityAnyContainerChildrenProps = {
  read: (id: number | string, options?: APICallOptions) => void;
};

// Hooks-based container to prevent infinite rerenders
export const EntityReadEntityAnyContainer: React.FC<
  IEntityReadEntityAnyContainerProps
> = ({ children, entityName }) => {
  const dispatch = useDispatch();

  const read = useCallback(
    (id: number | string, options?: APICallOptions) => {
      dispatch(readEntity(entityName, id, options));
    },
    [dispatch, entityName],
  );

  const childrenProps = useMemo(() => ({ read }), [read]);

  return children(childrenProps);
};
